export default __webpack_public_path__ + "static/media/arrow-left.b004632d.svg";